import React, {createContext, useContext, useState, useCallback} from "react";
const ModalContext = createContext({});

export default function ModalProvider({children}) {
  const [, setShowModal] = useState(false);

  const setModal = useCallback(bool => {
    setShowModal(bool);
  }, []);

  return <ModalContext.Provider value={{setModal}}>{children}</ModalContext.Provider>;
}

export const useModal = () => useContext(ModalContext);
